import React from 'react';
import './LandingCareLink.css';

// Rutas a las imágenes en public/img/prototypes/
const imgUsuario = "/img/prototypes/usuario_pulsera.jpeg";
const imgReloj = "/img/prototypes/prototipo reloj.jpg";
const imgChapa = "/img/prototypes/prototipo_final.jpg";
const imgLectura = "/img/prototypes/lectura.png";

export default function LandingCareLink() {
  return (
    <div className="carelink-page">
      {/* Navbar Header */}
      <header className="carelink-header">
        <div className="carelink-header-content">
          <div className="carelink-logo-container">
            <span className="carelink-logo-text">CareLink</span>
            <span className="carelink-logo-badge">NFC</span>
          </div>
          <span className="carelink-status-badge">
            ● Prototip Funcional
          </span>
        </div>
      </header>

      {/* Hero Section */}
      <section className="carelink-hero">
        <div className="carelink-hero-container">
          <div className="carelink-hero-text">
            <span className="carelink-hero-pretitle">Solució d'Emergència & Cures</span>
            <h1 className="carelink-hero-title">
              Identificació i assistència immediata per a persones vulnerables
            </h1>
            <p className="carelink-hero-description">
              Plataforma digital integrada amb identificadors NFC passius. Proporciona informació mèdica i de contacte essencial a equips d'emergència i cuidadors en segons.
            </p>
            
            <div className="carelink-tag-container">
              <span className="carelink-tag">Sense bateria</span>
              <span className="carelink-tag">Lectura instantània</span>
              <span className="carelink-tag">Compliment RGPD</span>
            </div>
          </div>

          <div className="carelink-hero-image-wrapper">
            <img 
              src={imgUsuario} 
              alt="Ús de la polsera CareLink NFC" 
              className="carelink-hero-image"
            />
            <div className="carelink-floating-card">
              <span className="carelink-floating-title">Intervenció Ràpida</span>
              <p className="carelink-floating-text">Lectura directa des de qualsevol smartphone sense instal·lar cap app.</p>
            </div>
          </div>
        </div>
      </section>

      {/* NFC Reading Showcase Section */}
      <section className="carelink-nfc-showcase">
        <div className="carelink-section-container">
          <div className="carelink-nfc-grid">
            <div className="carelink-nfc-text">
              <span className="carelink-hero-pretitle">Interfície d'Emergència</span>
              <h2 className="carelink-section-title" style={{ textAlign: 'left' }}>
                Visualització Immediata en el Mòbil
              </h2>
              <p className="carelink-card-text" style={{ fontSize: '16px', marginBottom: '20px' }}>
                En apropar qualsevol telèfon intel·ligent a la polsera, es desplega de forma automàtica la fitxa mèdica adaptada per a intervencions d'urgència.
              </p>
              
              <ul className="carelink-nfc-list">
                <li><strong>Notificació automàtica:</strong> S'obre al navegador sense instal·lar cap aplicació.</li>
                <li><strong>Alertes destacades:</strong> Identificació clara de patologies, al·lèrgies i grup sanguini.</li>
                <li><strong>Trucada directa:</strong> Botó d'acció ràpida per contactar amb el familiar o tutor legal.</li>
                <li><strong>Instruccions clares:</strong> Protocol d'assistència pas a pas per al ciutadà o sanitari.</li>
              </ul>
            </div>

            <div className="carelink-nfc-image-container">
              <img 
                src={imgLectura} 
                alt="Pantalla del mòbil amb la lectura NFC de CareLink" 
                className="carelink-nfc-mobile-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="carelink-section-gray">
        <div className="carelink-section-container">
          <div className="carelink-section-header">
            <h2 className="carelink-section-title">Ecosistema de Seguretat Integral</h2>
            <p className="carelink-section-subtitle">
              Dissenyat per connectar usuaris, familiars i serveis d'assistència de manera senzilla i eficaç.
            </p>
          </div>

          <div className="carelink-grid-three">
            <div className="carelink-card">
              <div className="carelink-icon-box">01</div>
              <h3 className="carelink-card-title">Identificació Física NFC</h3>
              <p className="carelink-card-text">
                Dispositiu lleuger, d'alta durabilitat i resistent a l'aigua. Funciona sense bateria ni manteniment per part de l'usuari.
              </p>
            </div>

            <div className="carelink-card">
              <div className="carelink-icon-box">02</div>
              <h3 className="carelink-card-title">Plataforma Núvol Segura</h3>
              <p className="carelink-card-text">
                Fitxa digital d'emergència amb contactes, al·lèrgies, patologies i protocols d'actuació actualitzables en temps real.
              </p>
            </div>

            <div className="carelink-card">
              <div className="carelink-icon-box">03</div>
              <h3 className="carelink-card-title">Accessibilitat Universal</h3>
              <p className="carelink-card-text">
                Compatible amb el 99% dels telèfons intel·ligents actuals. Protecció de dades adaptada a la normativa europea RGPD.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Hardware Prototyping Showcase */}
      <section className="carelink-section-white">
        <div className="carelink-section-container">
          <div className="carelink-section-header">
            <h2 className="carelink-section-title">Prototip de Dispositiu i Disseny</h2>
            <p className="carelink-section-subtitle">
              Elements físics desenvolupats per garantir la màxima visibilitat i facilitat d'ús en la via pública.
            </p>
          </div>

          <div className="carelink-grid-two">
            <div className="carelink-product-card">
              <div className="carelink-product-img-bg">
                <img src={imgReloj} alt="Polsera CareLink NFC" className="carelink-product-img" />
              </div>
              <div className="carelink-product-content">
                <h3 className="carelink-product-title">Polsera Assistencial de Silicona</h3>
                <p className="carelink-product-description">
                  Ergonòmica, hipoal·lergènica i d'alta visibilitat. Incorpora xip NFC passiu d'alta sensibilitat.
                </p>
              </div>
            </div>

            <div className="carelink-product-card">
              <div className="carelink-product-img-bg">
                <img src={imgChapa} alt="Interfície d'identificació" className="carelink-product-img" />
              </div>
              <div className="carelink-product-content">
                <h3 className="carelink-product-title">Identificador d'Alt Impacte Visual</h3>
                <p className="carelink-product-description">
                  Iconografia clara i instruccions d'emergència per guiar immediatament qualsevol persona que presti ajuda.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="carelink-footer">
        <div className="carelink-footer-container">
          <h4 className="carelink-footer-brand">CareLink NFC</h4>
          <p className="carelink-footer-text">Projecte presentat a l'Open Innovation Day, Health & Care 2026 — Terrassa Innovació</p>
          <p className="carelink-footer-subtext">Desenvolupament i arquitectura de programari per a la salut.</p>
        </div>
      </footer>
    </div>
  );
}